import { useEffect, useState } from 'react'

import { useEditPartsRequestMutation } from '@/buyers/_gen/gql'
import useGqlClient from '@/buyers/hooks/useGqlClient'
import ModalForm from '@/gf/components/ModalForm'
import TextArea from '@/gf/components/TextArea'
import useMsgs from '@/gf/hooks/useMsgs'

const EditPartsRequestModal = ({
  open,
  onClose,
  requestId,
  partsRequest,
  refetch,
}: {
  open: boolean
  onClose: () => void
  requestId: string
  partsRequest: string | null
  refetch: () => unknown
}) => {
  const [_, msgr] = useMsgs()
  const [value, setValue] = useState(partsRequest ?? '')
  const [saving, setSaving] = useState(false)
  const [editPartsRequest] = useEditPartsRequestMutation({ client: useGqlClient() })

  // Reopening picks up whatever is on the request now, including a value another
  // session saved while this modal was closed.
  useEffect(() => {
    if (open) setValue(partsRequest ?? '')
  }, [open, partsRequest])

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (saving) return
    setSaving(true)

    editPartsRequest({ variables: { id: requestId, partsRequest: value } })
      .then(() => {
        refetch()
        msgr.add('Additional details saved.', 'positive')
        onClose()
      })
      .catch((err) => {
        msgr.add(err.message || 'Error saving additional details', 'negative')
      })
      .finally(() => setSaving(false))
  }

  return (
    <ModalForm
      title="Edit Additional Details"
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      submitButtonText={saving ? 'Saving…' : 'Save'}
      submitButtonDisabled={saving}
    >
      <TextArea
        prose={false}
        rows={6}
        value={value}
        setValue={setValue}
        placeholder="Anything else the vendor should know about this request"
      />
    </ModalForm>
  )
}

export default EditPartsRequestModal
